import styled from 'styled-components';
import { Compensation } from '@/services/compensation';
import TableComponent from '@/trio-ui/Table';
import type { NewCompensationFlag } from './StaffMemberCompensationSection.component';

export const Table = styled(TableComponent<Compensation | NewCompensationFlag>)`
  tbody {
    td {
      & > div {
        display: flex;
        align-items: center;

        & > span {
          display: block;
          flex-grow: 1;
        }
      }
    }

    th:last-child,
    td:last-child {
      width: 52px;
    }

    td:last-child > div {
      display: flex;
      justify-content: space-between;
    }
  }
`;

export const TableContainer = styled.div`
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  & > div {
    overflow-x: unset;
    overflow-y: unset;
  }
`;
